import cloneDeep from 'lodash/cloneDeep';

class CustomerStatistics {
  constructor({visible, numberAnalysesYTD, lifetimePurchases, lastPurchaseAmount,
                lastPurchaseDate, totalPurchaseAmountYTD, avgPurchasePerAnalysis, threeStepPurchase}) {
    this.visible = visible;
    this.numberAnalysesYTD = numberAnalysesYTD;
    this.lifetimePurchases = lifetimePurchases;
    this.lastPurchaseAmount = lastPurchaseAmount;
    this.lastPurchaseDate = lastPurchaseDate;
    this.totalPurchaseAmountYTD = totalPurchaseAmountYTD;
    this.avgPurchasePerAnalysis = avgPurchasePerAnalysis;
    this.threeStepPurchase = threeStepPurchase;
  }

  clone() {
    return cloneDeep(this);
  }

  static fromApiFormat(api) {

    return new CustomerStatistics({
      visible: true,
      numberAnalysesYTD: api.statistics.numberAnalysesYTD,
      lifetimePurchases: api.statistics.lifetimePurchases,
      lastPurchaseAmount: api.statistics.lastPurchaseAmount,
      lastPurchaseDate: api.statistics.lastPurchaseDate,
      totalPurchaseAmountYTD: api.statistics.totalPurchaseAmountYTD,
      avgPurchasePerAnalysis: api.statistics.avgPurchasePerAnalysis,
      threeStepPurchase: api.statistics.threeStepPurchase,
    });
  }
}

export default CustomerStatistics;
